/** 
 * Copyright (c) INOVUA SOFTWARE TECHNOLOGIES.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function cleanProps(props, propTypes) {
  if (!props || !propTypes) {
    return Object.assign({}, props);
  }

  var newProps = Object.keys(props).reduce(function (acc, propName) {
    if (!propTypes[propName]) {
      acc[propName] = props[propName];
    }

    return acc;
  }, {});
  return newProps;
}

var _default = cleanProps;
exports.default = _default;